<template>
  <div class="profile-trips-tab">
    <div style="height: 8px" />
    <div class="trips-tab">
      <div class="tabs is-fullwidth is-boxed" style="margin-bottom:0">
        <ul class="trips-tabs has-text-weight-medium">
          <li :class="{'is-active': tab === 'Upcoming'}" @click="setTab($event)">
            <a id="Upcoming">{{ $t("profile.upcoming") }}</a>
          </li>
          <li :class="{'is-active': tab === 'Recent'}" @click="setTab($event)">
            <a id="Recent">{{ $t("profile.recent") }}</a>
          </li>
        </ul>
      </div>

      <div>
        <div class="card" v-if="!hasTransactions" style="margin-top:0">
          <div class="card-content">{{ noneText }}</div>
        </div>

        <div class="card" v-else style="margin-top:0">
          <div
            class="transactions card-content"
            v-for="t in transactions"
            :key="t.id"
            @click="goToTrip(t)"
          >
            <div class="content is-pulled-right" style="margin-top:20px">
              <span class="button icon is-white has-text-info">
                <i class="fa fa-chevron-right fa-2x" />
              </span>
            </div>
            <div class="content has-text-left">
              <p>
                <i class="fa fa-shuttle-van has-text-link" />
                &nbsp;
                {{ t.workflow_type_name }}&nbsp;
                <span
                  v-if="isUpcoming"
                >
                  <span class="tag is-link has-text-weight-semibold" v-if="isScheduled(t)">
                    <i class="fa fa-clock" style="margin-right:6px" />
                    {{ prettyState(t) }}
                  </span>
                  <span class="tag is-success has-text-weight-semibold" v-else>
                    <i class="fa fa-spinner fa-spin" style="margin-right:6px" />
                    {{ prettyState(t) }}
                  </span>
                </span>
                <span v-if="isRecent">
                  <span class="tag is-grey has-text-weight-semibold">{{ prettyState(t) }}</span>
                </span>
              </p>
              <p>
                <i class="fa fa-clock has-text-success" v-if="isUpcoming" />
                <i class="fa fa-check has-text-success" v-if="isRecent" />
                &nbsp;
                {{ longScheduledTime(t) }}
                <span
                  v-if="isUpcoming"
                  class="tag has-text-weight-semibold"
                >{{humanTime(t)}}</span>
              </p>
              <p>
                <i class="fa fa-coins" />
                &nbsp;
                <span v-if="isUpcoming">
                  <span>{{ prettyFare(t) }}</span>
                  <span v-if="isPrepaid(t)" class="tag is-grey has-text-weight-semibold">Prepaid</span>
                </span>
                <span v-else>
                  <span v-if="t.state === 'alighted'">{{ prettyFare(t) }}</span>
                  <span v-else>No Charge</span>
                </span>
                <!-- <span class="tag is-light is-pulled-right" v-if="isAgentBooking(t)">Agent Booking</span> -->
              </p>
              <p v-if="isAgentBooking(t)">
                <i class="fa fa-user" />
                &nbsp;
                Customer&nbsp;
                <span
                  class="has-text-weight-semibold"
                >{{ t.data.customer_name }}</span>
                <span class="tag is-light is-pulled-right">Agent Booking</span>
              </p>
              <div style="height: 11px" />
              <hr />
            </div>
          </div>
        </div>

        <!-- <div class="card" v-show="tab === 'Upcoming'">
          <div class="card-content">
            <i class="button fa fa-plus is-fullwidth is-info is-rounded" @click="addUpcomingTrip" />
          </div>
        </div>-->
        <br />
      </div>
      <button
        class="button is-warning is-rounded"
        @click="updateTrips(true)"
      >{{ $t("profile.roles-update")}}</button>
      <br />
      <br />
    </div>

    <EditTransactionModal />
    <RecentTransactionModal />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import EditTransactionModal from "@/components/EditTransactionModal.vue";
import RecentTransactionModal from "@/components/RecentTransactionModal.vue";

export default {
  components: {
    EditTransactionModal,
    RecentTransactionModal,
  },
  data() {
    return {
      tab: "Upcoming",
    };
  },
  computed: {
    hasTransactions() {
      if (this.transactions.length === 0) {
        return false;
      }
      return true;
    },
    transactions() {
      if (this.tab === "Recent") {
        return this.$store.getters.getRecentCustomerTransactions;
      }
      //   return this.$store.getters.getOngoingCustomerTransactions;
      return this.orderUpcomingTrips();
    },
    noneText() {
      if (this.tab === "Recent") {
        return this.$t("profile.no-recent-trips");
      }
      return this.$t("profile.no-upcoming-trips");
    },
    isUpcoming() {
      if (this.tab === "Upcoming") return true;
      return false;
    },
    isRecent() {
      if (this.tab === "Recent") return true;
      return false;
    },
  },
  mounted() {
    EventBus.$on("SET_TRIPS_TAB", (tab) => (this.tab = tab));
  },
  methods: {
    setTab(e) {
      this.tab = e.target.id;
    },
    orderUpcomingTrips() {
      var transactions = this.$store.getters.getOngoingCustomerTransactions;
      var ondemand = transactions.filter((t) => !t.data.scheduled_time);
      var scheduled = transactions.filter((t) => t.data.scheduled_time);
      scheduled.sort((a, b) => {
        return (
          new Date(a.data.scheduled_time) - new Date(b.data.scheduled_time)
        );
      });
      return ondemand.concat(scheduled);
    },
    isAgentBooking(t) {
      if (!t.data) return false;
      return t.data.agent;
    },
    isPrepaid(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.cash > 0) return false;
      if (!t.data.fare.tukpay) return false;
      return true; // means cash === 0
    },
    isScheduled(t) {
      if (t.state === "scheduled") return true;
      return false;
    },
    isOngoing(t) {
      if (t.state !== "scheduled" && t.is_ongoing) return true;
      return false;
    },
    goToTrip(t) {
      if (t.state === "scheduled") {
        EventBus.$emit("EDIT_TRANSACTION", t); // VIEW_TRANSACTION
        this.$nextTick(() => this.displayModal(".edit-transaction-modal"));
        return;
      }
      if (!t.is_ongoing) {
        EventBus.$emit("RECENT_TRANSACTION", t);
        this.$nextTick(() => this.displayModal(".recent-transaction-modal"));
        return;
      }
      if (this.$store.state.endedTransactions.find((e) => e === t.id)) {
        EventBus.$emit("EDIT_TRANSACTION", t); // VIEW_TRANSACTION
        this.displayModalNext(".edit-transaction-modal");
        return;
      }
      this.$router.push("/tuktuk"); // else go to transport page
    },
    prettyState(t) {
      return t.state;
    },
    prettyFare(t) {
      if (t.data.fare) {
        if (t.data.fare.cash > 0) {
          return `฿ ${t.data.fare.cash} via Cash`;
        }
        if (!t.data.fare.tukpay) {
          return `Ask your driver for fare details`;
        }
        return `฿ ${t.data.fare.tukpay} via TukPay`;
      }
      return "Free of Charge";
    },
    addUpcomingTrip() {
      this.$router.push("/tuktuk");
    },
    reOrder(r) {
      this.console("reorder for role", r);
      this.$router.push(`/tuktuk?workflow_id=${r.workflow_id}`).catch((err) => {
        console.error("reOrder router.push error", err);
      });
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0px -20px 0px; /* margin: 0 0; */
}
p {
  margin-bottom: 0px !important;
}
.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}
.trips-tab {
  overflow: auto;
  height: 75vh;
}
.card {
  margin-top: 10px;
}
.transactions.card-content {
  padding: 18px;
  padding-bottom: 0px;
}
</style>